<ng-container *yatVar="(billingAddresses$ | async)?.length as length">
  <div *ngIf="!billingAddressRequired; else billingRequiredTemplate">
    <a
      yat-link
      class="link add link-secondary"
      yatTabSelectable
      (tabSelect)="select(length === 0)"
      [matomoClickCategory]="MATOMO_EVENT_CATEGORY_BILLING"
      matomoClickAction="Submit_FirstBillingAddress"
      ><yat-icon id="ebe2f4c5-5ccc-4cdc-84f6-47ec4a3898ea" name="plus-circle" class="mr-1"></yat-icon>{{ 'checkout.billingInformation.noBillingAddressSelectedPanel.addBillingAddress' | transloco }}</a
    >
  </div>
  <ng-template #billingRequiredTemplate>
    <div class="panel-btn" yatTabSelectable (tabSelect)="select(length === 0)">
      <div class="row" *ngIf="length === 0">
        <div class="col-12">
          <div class="icons">
            <span class="static-icon mt-0">
              <yat-icon id="df8961ee-cdb2-41ca-a8d0-6661306a13ec" [class.hover-icon]="!isMobile()" name="plus-circle-duo"></yat-icon>
            </span>
          </div>
          <div *ngIf="businessModel$ | async as businessModel">
            <p class="m-0" *ngIf="businessModel === 'B2C'; else otherTemplate">
              {{ 'checkout.billingInformation.noBillingAddressSelectedPanel.addBillingAddress' | transloco }}
            </p>
            <ng-template #otherTemplate>
              <p class="m-0">
                {{ 'checkout.billingInformation.noBillingAddressSelectedPanel.enterBillingAddressAndVat' | transloco }}
              </p>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="length && length > 0">
        <div class="col-12">
          <div class="icons">
            <span class="static-icon">
              <yat-icon id="604717c0-f9d8-494e-b832-3b2e7f42f1e6" class="chevron-right" *ngIf="isMobile()" name="chevron-right"> </yat-icon>
              <yat-icon id="26a1e4ab-29bd-4c0e-a8bf-91a1b9abc0d5" class="p-1" *ngIf="!isMobile()" [class.hover-icon]="!isMobile()" name="cog-duo"></yat-icon>
            </span>
          </div>
          <p class="m-0">{{ 'checkout.billingInformation.noBillingAddressSelectedPanel.noBillingAddressSelected' | transloco }}</p>

          <span class="c-gray d-block">
            {{ 'checkout.billingInformation.noBillingAddressSelectedPanel.billingAddressSaved' | transloco: { length: this.length } }}
          </span>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
